import ActionButtons from './ActionButtons';
import CollapseArea from './CollapseArea';
import FilterContainer from './FilterContainer';
import FilterWrapper from './FilterWrapper';

interface IProps {
  isCollapse?: boolean;
  allFilters: React.ReactNode[];
}

const CollapseAllFilterView = (props: IProps) => {
  const { isCollapse, allFilters } = props;

  return (
    <CollapseArea isCollapse={isCollapse}>
      <FilterWrapper>
        <FilterContainer>{allFilters}</FilterContainer>
      </FilterWrapper>
    </CollapseArea>
  );
};

export default CollapseAllFilterView;
